import React from 'react';
import { Text as BasicText } from './Text';
import escapeRegExp from 'lodash/escapeRegExp';

const TextWithHighlight = ({ value, children, ...props }) => {
    return (
        <BasicText {...props}>
            {value}
            {children}
        </BasicText>
    );
};

const Space = () => <BasicText> </BasicText>;

const ellipses = (word, searchTerm, length) => {
    if (word.length <= length) {
        return word;
    }

    const firstIndex = word.indexOf(searchTerm);
    (lastIndexOfSpaceBeforeWord = word.subString(0, firstIndex).lastIndexOf(' ')),
        (strippedString =
            lastIndexOfSpaceBeforeWord > 0
                ? word.subString(lastIndexOfSpaceBeforeWord, length)
                : word.subString(0, length)),
        (prefix = firstIndex > 0 ? '...' : ''),
        (suffix = strippedString.splice(searchTerm.length).length > 0 ? '...' : '');

    return `${prefix}${strippedString}${suffix}`;
};

export const factory = ({ Text = TextWithHighlight, WhiteSpace = Space } = {}) => {
    const HighLightText = React.memo(({ value, searchTerm = ' ', ...props }) => {
        if (typeof value !== 'string') {
            return <Text value={value} {...props} />;
        }

        if (typeof searchTerm !== 'string' || !searchTerm) {
            return <Text value={value} {...props} />;
        }

        const { maxLength = 0, ...rest } = props,
            isWhiteSpaceNoise = !searchTerm.trim();

        let counter = 0,
            renderTerm = (maxLength <= 0 ? value : ellipses(value, searchTerm, maxLength)).replace(/\s+/g, ' ');

        if (isWhiteSpaceNoise) {
            const left =
                value.trimLeft().length !== value.length ? <WhiteSpace {...rest} key={'space-left' + value} /> : [];
            const right =
                value.trimRight().length !== value.length ? <WhiteSpace {...rest} key={'space-right' + value} /> : [];
            return [left].concat(<Text key={value} highlight={false} value={value.trim()} {...rest} />).concat(right);
        }

        if (searchTerm) {
            const searchRegex = new RegExp(escapeRegExp(searchTerm), 'ig');
            const matches = renderTerm.match(searchRegex);
            if (!matches) {
                return <Text key={renderTerm} value={renderTerm} {...props} />;
            }

            renderTerm = renderTerm.split(searchRegex).reduce((renderComponents, subString, i) => {
                const key = subString + '_' + searchTerm + '_' + counter++;
                if (i > 0) {
                    const replacedComponent = <Text key={key} highlight value={matches?.[i - 1]} {...rest} />;
                    renderComponents.push(replacedComponent);
                }

                return renderComponents.concat(<HighLightText key={key + 'highlight'} value={subString} {...rest} />);
            }, []);
        }

        return (
            <BasicText {...rest} display="inline">
                {renderTerm}
            </BasicText>
        );
    });

    return HighLightText;
};

export { factory as highlightFactory };
export const HighLightText = factory({});
